import React from 'react';
import styles from './HeroSection.module.css';

const HeroSection = ({
  title,
  subtitle,
  gradientFrom = '#F97738',
  gradientTo = '#FCB999',
  titleColor = 'white',
  className = '',
  subtitleSize
}) => {
  const heroStyle = {
    background: `linear-gradient(180deg, ${gradientFrom} 2.01%, ${gradientTo} 100%)`,
    '--title-color': titleColor,
    '--subtitle-color': 'rgb(255 255 255 / 23%);'
  };

  return (
    <div className={`${styles.heroSection} ${className}`} style={heroStyle}>
      <div className={styles.heroContent}>
        <h1 className={styles.heroTitle}>{title}</h1>
    
        <div className={styles.heroSubtitle}  style={{ fontSize: subtitleSize }}>{subtitle}</div>
      </div>
    </div>
  );
};

export default HeroSection;
